import { LightUpChochin } from "./LightUpChochin.client";

export function LightUpChochinList(props) {
  return (
    <ul className={props.className + " lightUpChochinList"}>
      {
        [
          {
            link : 'products/meiji', videoA : '/m/light-7.mp4', videoB : '/m/light-7re.mp4',
            title : 'Meiji', price : '43,600', poster: '/m/light-7.jpg', titleJa : '明治'
          },
          {
            link : 'products/nishaku-maru', videoA : '/m/light-2.mp4', videoB : '/m/light-2re.mp4',
            title : 'Nishaku-maru', price : '80,000', poster: '/m/light-2.jpg', titleJa : '二尺丸'
          },
          {
            link : 'products/shakugo-maru', videoA : '/m/light-3.mp4', videoB : '/m/light-3re.mp4',
            title : 'Shakugo-maru', price : '60,000', poster: '/m/light-3.jpg', titleJa : '尺五丸'
          },
          {
            link : 'products/shaku-maru', videoA : '/m/light-4.mp4', videoB : '/m/light-4re.mp4',
            title : 'Shaku-maru', price : '38,000', poster: '/m/light-4.jpg', titleJa : '尺丸'
          },
          {
            link : 'products/nishaku-kansu', videoA : '/m/light-5.mp4', videoB : '/m/light-5re.mp4',
            title : 'Nishaku-kansu', price : '85,000', poster: '/m/light-5.jpg', titleJa : '二尺カンス'
          },
          {
            link : 'products/houto', videoA : '/m/light-6.mp4', videoB : '/m/light-6re.mp4',
            title : 'Houto', price : '75,000', poster: '/m/light-6.jpg', titleJa : '豊灯'
          },
        ].map(product=>{
          return (
            <LightUpChochin {...product}></LightUpChochin>
          )
        })
      }
    </ul>
  )
}